import { Dialog, DialogContent } from '@superfunnel/ui-core/v2/Dialog';
import SubscriptionPlans from '../screens/settings/SubscriptionPlans';

interface Props {
  open: boolean;
  onClose: () => void;
}

export default function SubscriptionRequiredModal({ open, onClose }: Props) {
  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen: boolean) => !isOpen && onClose()}
    >
      <DialogContent
        className="flex h-[95vh] w-[90vw] max-w-[90vw] flex-col overflow-clip p-0"
        showCloseButton={true}
      >
        <div className="min-h-0 flex-1 overflow-y-auto">
          <SubscriptionPlans
            header={
              <div className="flex flex-col items-center gap-2 py-4 text-center">
                <h2 className="text-2xl font-semibold text-[#141c25]">
                  To continue, pick a plan
                </h2>
                <p className="text-base text-[#414e62]">
                  Choose the plan that best fits your needs to start optimizing
                  your funnels.
                </p>
              </div>
            }
            customPlanLayout="inline"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
